import React from "react";
import { useNavigate } from "react-router-dom";
import { FaUsers } from "react-icons/fa";
import getImageUrl from "../../utils/imageUtils";
import styles from "../../styles/pages/users/UserSearchPage.module.css";

const UserCard = ({ user }) => {
  const navigate = useNavigate();
  const followerCount = Number(user.followerCount || 0);

  return (
    <button
      type="button"
      className={styles.userCard}
      onClick={() => navigate(`/user/${user._id}`)}
    >
      <div className={styles.userAvatar}>
        {user.avatar ? (
          <img
            src={getImageUrl(user.avatar)}
            alt={`${user.firstName} ${user.lastName}`}
          />
        ) : (
          <div className={styles.avatarPlaceholder}>
            {user.firstName?.[0] || user.username?.[0] || "U"}
          </div>
        )}
      </div>
      <div className={styles.userInfo}>
        <h3 className={styles.userName}>
          {user.firstName} {user.lastName}
        </h3>
        {user.username && <p className={styles.username}>@{user.username}</p>}
        {user.bio && (
          <p className={styles.bio} title={user.bio}>
            {user.bio}
          </p>
        )}
        <div className={styles.userStats}>
          <span className={styles.stat}>
            <FaUsers /> {followerCount} followers
          </span>
          {user.tier && <span className={styles.stat}>{user.tier}</span>}
        </div>
      </div>
    </button>
  );
};

export default React.memo(UserCard);
